import { useI18n } from 'vue-i18n'
import type { EventDescription } from '~/composables/types/event'

const dictionary = {
  tour: {
    about: 'product.titleByCategory.tour.about',
    location: 'product.titleByCategory.tour.location',
    courseTarget: 'product.titleByCategory.tour.courseTarget',
    progress: 'product.titleByCategory.tour.progress',
  },
  kit: {
    about: 'product.titleByCategory.kit.about',
    progress: 'product.titleByCategory.kit.progress',
    courseTarget: 'product.titleByCategory.kit.courseTarget',
    whatToBring: 'product.titleByCategory.kit.whatToBring',
    whatIsIncluded: 'product.titleByCategory.kit.whatIsIncluded',
  },
  course: {
    about: 'product.titleByCategory.course.about',
    progress: 'product.titleByCategory.course.progress',
    courseTarget: 'product.titleByCategory.course.courseTarget',
    whatToBring: 'product.titleByCategory.course.whatToBring',
    whatIsIncluded: 'product.titleByCategory.course.whatIsIncluded',
    location: 'product.titleByCategory.course.location',
  },
  experience: {
    about: 'product.titleByCategory.experience.about',
    progress: 'product.titleByCategory.experience.progress',
    courseTarget: 'product.titleByCategory.experience.courseTarget',
    whatToBring: 'product.titleByCategory.experience.whatToBring',
    whatIsIncluded: 'product.titleByCategory.experience.whatIsIncluded',
    location: 'product.titleByCategory.experience.location',
  },
}

export function useTitleByCategory() {
  const { t } = useI18n()

  const getTitleByCategory = (
    section: string,
    eventData: EventDescription | undefined,
    isGiftcard: boolean = false
  ): string => {
    const specialization = eventGetters
      .getSpecialization(eventData)
      ?.toLowerCase()

    const defaultTitles = {
      about:
        isGiftcard || eventGetters.isGiftcardEvent(eventData)
          ? t('product.show.basicDetails.giftcardDescription')
          : t('product.show.basicDetails.description'),
      progress:
        isGiftcard || eventGetters.isGiftcardEvent(eventData)
          ? t('product.show.basicDetails.giftcardCourseProgress')
          : t('product.show.basicDetails.courseProgress'),
      courseTarget:
        isGiftcard || eventGetters.isGiftcardEvent(eventData)
          ? t('product.show.basicDetails.giftcardCourseTarget')
          : t('product.show.basicDetails.courseTarget'),
      detailsToRemember: t('product.show.basicDetails.detailsToRemember'),
      whatToBring:
        isGiftcard || eventGetters.isGiftcardEvent(eventData)
          ? t('product.show.basicDetails.giftcardWhatToBring')
          : t('product.show.basicDetails.whatToBring'),
      whatIsIncluded:
        isGiftcard || eventGetters.isGiftcardEvent(eventData)
          ? t('product.show.basicDetails.giftcardWhatIsIncluded')
          : t('product.show.basicDetails.whatIsIncluded'),
      languages: t('product.show.icons.languages.title'),
    }

    if (isGiftcard || eventGetters.isGiftcardEvent(eventData)) {
      return defaultTitles[section as keyof typeof defaultTitles]
    }

    if (specialization && Object.keys(dictionary).includes(specialization)) {
      return dictionary[specialization][section]
        ? t(dictionary[specialization][section])
        : defaultTitles[section]
    }

    return defaultTitles[section]
  }

  return { getTitleByCategory }
}
